export const version = '2.5.19';
//# sourceMappingURL=version.js.map